import React from 'react';

const SvgTwitter = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 17 14" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.559 2.052c-.6.266-1.245.445-1.921.526a3.352 3.352 0 0 0 1.47-1.85 6.695 6.695 0 0 1-2.123.811 3.344 3.344 0 0 0-5.698 3.05 9.493 9.493 0 0 1-6.893-3.493A3.343 3.343 0 0 0 2.43 5.56a3.32 3.32 0 0 1-1.514-.42v.043a3.345 3.345 0 0 0 2.682 3.278 3.333 3.333 0 0 1-1.51.058 3.347 3.347 0 0 0 3.124 2.322A6.71 6.71 0 0 1 .26 12.225a9.46 9.46 0 0 0 5.125 1.502c6.151 0 9.515-5.094 9.515-9.512 0-.145-.004-.29-.01-.433a6.78 6.78 0 0 0 1.669-1.73z"
    />
  </svg>
);

export default SvgTwitter;
